import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Space, Table, TableProps, Tag, Button } from 'antd';
import { searchHistoryAlarms, getDefaultProject } from '../../api/onlineDatas';
import Filter from './Filter'
import { apis } from '../../constants';
import { dateTimeRender, parseSearchParams, textRender, downloadFile } from '../../utils';
import { useSearchParams } from 'react-router-dom';

const { Column } = Table;

const HistoryAlarms: React.FC<{
    showCertain?: {
        projectId: any, devSn: any
    }
}> = ({ showCertain }) => {
    const defaultProjectIdFetchedRef = useRef(false);
    const [searchParams] = useSearchParams();
    const [downloading, setDownloading] = useState(false)
    const initalParams = parseSearchParams<Partial<Omit<SearchLogParams, 'pageNum' | 'pageSize'> & {isHistory?: string}>>(searchParams)
    const [params, setParams] = useState<Partial<Omit<SearchLogParams, 'pageNum' | 'pageSize'>>>({
        ...initalParams,
        ...(
            initalParams.isHistory === '1' ? {} :
            {
                receivedStartDate: dateTimeRender(new Date().getTime() - 3 * 24 * 60 * 60 * 1000),
                receivedEndDate: dateTimeRender(new Date().getTime()),
            }
        ),
        switchNumber: initalParams.switchNumber ? Number(initalParams.switchNumber) : undefined,
    });
    const [pagination, setPagination] = useState<Pick<SearchLogParams, 'pageNum' | 'pageSize'>>({
        pageNum: 1,
        pageSize: 10,
    });
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<PagedData<AlarmRecord>>({
        pageNum: 1,
        pageSize: 10,
        total: 0,
        data: [],
    });
    const fetchData = useCallback(() => {
        if (defaultProjectIdFetchedRef.current === false) return;
        setLoading(true);
        searchHistoryAlarms(showCertain ? { ...showCertain, ...pagination } : { ...params, ...pagination })
            .then(setData)
            .finally(() => { setLoading(false) });
    }, [JSON.stringify(params), pagination, showCertain]);

    useEffect(fetchData, [fetchData]);
    useEffect(() => {
        setParams({
            ...params,
            ...initalParams,
            switchNumber: initalParams.switchNumber ? Number(initalParams.switchNumber) : undefined,
        });
    }, [initalParams.projectId, initalParams.devSn]);
    useEffect(() => {
        if (defaultProjectIdFetchedRef.current === true) return;
        getDefaultProject()
        .then(res => {
            defaultProjectIdFetchedRef.current = true;
            setParams({...params, projectId: String(res.projectId)});
        });
    }, [JSON.stringify(params)]);
    return (
        <>
            {showCertain ? null :
                <>
                    <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Filter slot={<Button loading={downloading} type='primary' style={{marginLeft: '1em'}} onClick={() => {
                           setDownloading(true)
                           downloadFile(apis.alarmDownload, params)
                           .finally(() => {
                            setDownloading(false)
                           })
                        }}>数据导出</Button>} values={params} onChange={setParams} onSearch={fetchData} />
                    </Space>
                    <br />
                    <br />
                </>
            }
            <HistoryAlarmTable scroll={{ x: 1 }}
                pagination={{
                    pageSize: pagination.pageSize,
                    current: pagination.pageNum,
                    total: data.total,
                    onChange: (pageNum, pageSize) => {
                        setPagination({
                            ...pagination,
                            pageSize,
                            pageNum
                        })
                    }
                }}
                dataSource={Array.isArray(data.data) ? data.data : []} loading={loading}>
            </HistoryAlarmTable>
        </>
    );
}

export const HistoryAlarmTable = (props: TableProps) => {
    return (
        <Table scroll={{ x: 1 }}
            pagination={props.pagination}
            dataSource={props.dataSource}
            loading={props.loading}>
            <Column title="展会名称" dataIndex="projectName" key="projectName" />
            <Column title="设备序列号" dataIndex="deviceSn" key="deviceSn" />
            <Column title="开关号" render={textRender} dataIndex="switchNumber" key="switchNumber" />
            <Column title="网关" render={textRender} dataIndex="gatewayMac" key="gatewayMac" />
            <Column title="状态"  width={100} render={(alarmStatus: number) => {
                return alarmStatus === 0 ? <Tag color='green'>恢复</Tag> : <Tag color='red'>报警</Tag>
            }} dataIndex="alarmStatus" key="alarmStatus" />
            <Column title="告警信息" dataIndex="description" key="description" />
            <Column title="接收时间" sorter dataIndex="receiveDatetime" key="receiveDatetime" render={time => {
                return dateTimeRender(time)
            }} />
        </Table>
    )
}

export default HistoryAlarms;